import React from "react";
import {
    Datagrid,
    List,
    TextField,
} from 'react-admin';

const RubricList = (props) => (
    <List {...props} >
        <Datagrid rowClick="edit">
            <TextField source="title" label="Titre" />
            <TextField source="subtitle" label="Sous-titre" />
        </Datagrid>
    </List>
);

export default RubricList;
